import React from 'react'

import EditableItemFooter from './EditableItemFooter'
import OwnBookingFooter from './OwnBookingFooter'
import ReadOnlyItemFooter from './ReadOnlyItemFooter'

import TextButton from 'components/Luxkit/Button/TextButton'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCurrentUserId } from 'selectors/accountSelectors'
import FooterWithCreateUpdateInfo from 'tripPlanner/components/TripModal/Common/FooterWithCreateUpdateInfo'
import { FlightItem } from 'tripPlanner/types/tripItem'
import { getOrderId, isLeBookmark } from 'tripPlanner/utils'
import { buildStandaloneFlightSearchURL } from 'tripPlanner/utils/bookmark/deepLink'

interface Props {
  item: FlightItem
}

export default function FlightSummaryModalFooter({ item }: Props) {
  const orderId = getOrderId(item)
  const userId = useAppSelector(getCurrentUserId)

  const isBookedLEFlight = item.sourceType === 'LE_Flight' && orderId

  if (isBookedLEFlight && orderId) {
    if (item.createdBy === userId) {
      return <OwnBookingFooter item={item} orderId={orderId} />
    } else {
      return <ReadOnlyItemFooter item={item} />
    }
  } else if (isLeBookmark(item)) {
    const flightSearchQueryString = buildStandaloneFlightSearchURL(
      item.savedItemData,
    )
    return (
      <FooterWithCreateUpdateInfo item={item}>
        <TextButton
          kind="primary"
          to={`/flights-search-results${flightSearchQueryString}`}
          target="_blank"
        >
          Select flights
        </TextButton>
      </FooterWithCreateUpdateInfo>
    )
  } else {
    return <EditableItemFooter item={item} />
  }
}
